// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileExclamationOutlinedSvg from "@fishx/icons-svg/es/asn/PFileExclamationOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileExclamationOutlined = function PFileExclamationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileExclamationOutlinedSvg
  }));
};

PFileExclamationOutlined.displayName = 'PFileExclamationOutlined';
export default React.forwardRef(PFileExclamationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileExclamationOutlined.js
// module id = 3390
// module chunks = 0